import * as _ from 'lodash';

class FactorajeFinancieroRequest {
  data = {};

  constructor(data) {
    this.data = _.cloneDeep(data);
  }

  static make(data) {
    return new FactorajeFinancieroRequest(data);
  }

  apply() {
    return this.data.map((element) => {
      return {
        FechaPago: element.FechaPago,
        HoraPago: element.HoraPago,
        FormaDePagoP: element.FormaDePagoP,
        Monto: element.Monto,
        MonedaP: element.MonedaP,
        TipoCambioP: element.TipoCambioP,
        DoctoRelacionado: [
          {
            IdDocumento: element.IdDocumento,
            MonedaDR: element.MonedaDR,
            EquivalenciaDR: element.EquivalenciaDR,
            NumParcialidad: element.NumParcialidad,
            ImpSaldoAnt: element.ImpSaldoAnt,
            ImpPagado: element.ImpPagado,
            ImpSaldoInsoluto: element.ImpSaldoInsoluto,
            ObjetoImpDR: element.ObjetoImpDR,
            ImpuestosDR: element.ImpuestosDR,
          },
        ],
      };
    });
  }
}

export default FactorajeFinancieroRequest;
